module.exports = __webpack_public_path__ + "img/ls-logo-v2.f5ca7207.png";